import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class ExpensesPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ExpensesPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>expenses go here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

ExpensesPage.meta = {
    label: <FormattedMessage id={'expenses'} defaultMessage={'Expenses'} />,
    icon: 'receipt',
    action: () => history.push('/expenses'),
    locations: ['/expenses']
};

export default ExpensesPage;



// WEBPACK FOOTER //
// ./src/pages/expenses/index.jsx